import React from 'react';
import { AppBar, Toolbar, Container, CircularProgress, Typography } from '@material-ui/core'
import Logo from '../../assets/inline_logo.png';
import EmptyPicture from '../../assets/empty_picture.png';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import DetailCourse, { TAB } from './DetailCourse';

const FETCH_ME = gql`
    query{
        fetchMe {
            avatar
            document
            name
            email
            first_access
            current_course_unit_id
        }
    }
`;

const AVATAR_SIZE = 45;

const handleOpenSettings = props => {
    props.history.push("/settings");
};

/**
 * Aba e livro selecionados ficam na URL (?tab=extras&unit=12) para sobreviverem
 * à ida e volta do /detail. Valores inválidos caem no padrão.
 */
const parseHomeParams = (search, defaultCourseUnitId) => {
    const params = new URLSearchParams(search);
    const courseUnitId = Number(params.get('unit'));

    return {
        tab: params.get('tab') === TAB.EXTRAS ? TAB.EXTRAS : TAB.CHAPTERS,
        courseUnitId: Number.isInteger(courseUnitId) && courseUnitId > 0 ? courseUnitId : defaultCourseUnitId
    };
};

const updateHomeParams = (props, changes) => {
    const params = new URLSearchParams(props.location.search);

    Object.keys(changes).forEach(key => params.set(key, changes[key]));

    props.history.replace({ search: `?${params.toString()}` });
};

const HomePage = props => {

    let { loading, error, fetchMe } = props.data;

    if (loading) return <div style={{ textAlign: 'center', padding: 48 }}><CircularProgress /></div>;
    if (error) return <Typography color="error" style={{ padding: 24 }}>Não foi possível carregar seus dados. Tente novamente mais tarde.</Typography>;

    const { tab, courseUnitId } = parseHomeParams(props.location.search, fetchMe.current_course_unit_id);

    return (
        <>
        <AppBar position="static" color="primary">
            <Toolbar style={{ backgroundColor: '#FFF', display: 'flex', justifyContent: 'space-between' }}>
                {/* Espaçador do mesmo tamanho do avatar para o logo ficar centralizado de verdade. */}
                <div style={{ width: AVATAR_SIZE }} />
                <img src={Logo} alt="Luziana Lanna" style={{ height: 40, maxWidth: 'calc(100% - 110px)', objectFit: 'contain' }} />
                <img
                    onClick={() => handleOpenSettings(props)}
                    src={fetchMe.avatar ? fetchMe.avatar : EmptyPicture}
                    alt="Configurações do perfil"
                    style={{ width: AVATAR_SIZE, height: AVATAR_SIZE, borderRadius: '50%', cursor: 'pointer', objectFit: 'cover' }}
                />
            </Toolbar>
        </AppBar>
        <Container maxWidth="md" style={{ marginTop: 24, marginBottom: 24, textAlign: 'left' }}>
            {/* key: remonta ao trocar de livro, evitando exibir dados do livro anterior enquanto carrega. */}
            <DetailCourse
                key={courseUnitId}
                course_unit_id={courseUnitId}
                tab={tab}
                history={props.history}
                onChangeTab={newTab => updateHomeParams(props, { tab: newTab })}
                onChangeCourseUnit={newCourseUnitId => updateHomeParams(props, { unit: newCourseUnitId })}
            />
        </Container>
    </>
  );
}

export default graphql(FETCH_ME)(HomePage);
